import Vue from 'vue'
import App from './App.vue'
import router from './router'
import gtagAPI from './apis/gtag.js'
import fbqAPI from './apis/fbq.js'
import swalPlugin from './utils/toast.js'

// 初始化時，自動匹配 device-width
const width = document.documentElement.clientWidth
if (width < 576) {
  const scale = +(width / 576).toFixed(2)
  document
    .querySelector('meta[name=viewport]')
    .setAttribute('content', `width=device-width, initial-scale=${scale}`)
}

// Load and set Google Analytics and Facebook Pixel
if (window.location.hostname === 'tonicdrink.sfworldwide.com') {
  gtagAPI.initGtag()
  fbqAPI.initFbq()
}

Vue.use(swalPlugin)
Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
